import { createFileRoute, redirect } from "@tanstack/react-router";
import { productSlugRedirectUrl } from "@/components/inventory/FilterRedirects";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/product/$slug/$feature")({
  head: () => pageHead({ title: 'Rex & Sons RVs', description: 'Rex & Sons RVs — family-owned RV dealer in Castle Hayne, NC since 1997. Sales, service, parts and rentals.', path: '/product/:slug/:feature' }),
  beforeLoad: ({ params }) => {
    throw redirect({
      href: productSlugRedirectUrl(params.slug, params.feature),
      statusCode: 301,
      throw: true,
    });
  },
});
